import { useEffect } from "react";
import { LandingPage } from ".";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { useIsEmailHubStatusEnabled } from "@circle-react/hooks/useIsEmailHubStatus";
import { Modal } from "@circle-react-uikit/ModalV2";

const EmailHubModalComponent = ModalManager.create(() => {
  const modal = useModal();
  const onClose = () => modal.hide();

  const isEmailHubEnabled = useIsEmailHubStatusEnabled();

  useEffect(() => {
    if (isEmailHubEnabled) {
      void modal.hide();
    }
  }, [isEmailHubEnabled]);

  return (
    <Modal isOpen={modal.visible} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content size="2xl">
        <Modal.Header className="flex flex-row-reverse md:hidden">
          <Modal.CloseButton onClick={onClose} />
        </Modal.Header>
        <Modal.Body>
          <LandingPage modal />
        </Modal.Body>
      </Modal.Content>
      <Modal.Footer>
        <div className="py-4" />
      </Modal.Footer>
    </Modal>
  );
});

export const useEmailHubModal = () => useModal(EmailHubModalComponent);
